/**
 * A person together with their institution, as the record detail shows them (CZNA-1616):
 * "Jana Nováková (ABA001)". The supervisor and the cataloguer need to know which library a
 * record came from — whom to contact, whose practice it carries — and the name alone does
 * not say that.
 *
 * Without a sigla (no organization, an organization without one, the System/Import labels,
 * an unresolved id) the name is returned unchanged: no empty parentheses, no dash. A pure
 * data composition, so it is not a translation.
 */
export var formatUserWithSigla = function (name, sigla) {
    if (!name)
        return name;
    var trimmed = sigla === null || sigla === void 0 ? void 0 : sigla.trim();
    return trimmed ? "".concat(name, " (").concat(trimmed, ")") : name;
};
